/**
 * Gemeinsamer Vertrag zwischen Server und allen Oberflächen (Browser jetzt, SSH später).
 *
 * Grundsatz aus dem Konzept (Kap. 9): Der Server ist die einzige Wahrheit.
 * Die Oberfläche schickt nur rohe Eingabezeilen und zeichnet, was der Server ihr sagt.
 * Deshalb gibt es hier bewusst KEIN HTML - nur Textsegmente mit semantischen Stilnamen,
 * die jede Oberfläche selbst übersetzt (CSS im Browser, ANSI-Farben im SSH-Client).
 */
export const PROTOCOL_VERSION = 1;
export const LIMITS = {
    /** Maximale Länge einer Eingabezeile, die der Server annimmt. */
    inputLength: 200,
    /** Max. Spieler pro Raum (Konzept Kap. 2). */
    playersPerRoom: 8,
    /** Standard-Fragenzahl Singleplayer / Multiplayer (Konzept Kap. 2/3). */
    defaultQuestionsSolo: 10,
    defaultQuestionsRoom: 20,
    /** Zeitlimit-Korridor pro Frage in Sekunden (Konzept Kap. 6). */
    minTimeLimitSec: 8,
    maxTimeLimitSec: 20,
};
export const THEMES = {
    lila: { name: 'lila', accent: '#a78bfa', accent2: '#7c3aed' },
    cyan: { name: 'cyan', accent: '#22d3ee', accent2: '#0891b2' },
    matrix: { name: 'matrix', accent: '#4ade80', accent2: '#16a34a' },
    amber: { name: 'amber', accent: '#fbbf24', accent2: '#d97706' },
};
export const DEFAULT_THEME = 'lila';
/* --------------------------------------------------------------- Hilfsmittel */
export const seg = (t, s) => (s ? { t, s } : { t });
export const line = (text, s) => ({ segs: [seg(text, s)] });
/** Wie `line()`, aber mit Tipp-Effekt (Konzept Kap. 7: "Tipp-Effekt für KI-Ausgaben"). */
export const typed = (text, s) => ({ segs: [seg(text, s)], typewriter: true });
export const blank = () => ({ segs: [] });
export const segs = (...parts) => ({ segs: parts });
/** Überschrift im Stil "━━ Titel ━━━━━━━━━━". */
export function rule(title, s = 'accent', width = 46) {
    const head = `━━ ${title} `;
    const tail = '━'.repeat(Math.max(2, width - head.length));
    return line(head + tail, s);
}
//# sourceMappingURL=index.js.map